import * as React from 'react';
import "react-datepicker/dist/react-datepicker.css";
import BarChart from '../Bar';
import Chart from '../Chart';
import Column from '../Column';
import List from '../List';
import Frame from '../Frame';
import IFrame from '../IFrame';
import Slider from '../Slider';
import Pie from '../Pie';
import Column_Pie from '../Column_Pie';
import Bar_List from '../BarList';
import Line_List from '../LineList';
import moment, { relativeTimeRounding } from 'moment';
import $ from 'jquery';
import filterIcon from '../css/dark/img/filter.svg';
import Claim from '../Claim';
import Claim_New from '../Claim_New';
import FilterTagCom from '../FilterTag';
import MultiStack_List_2 from '../MultiAxisBar_List';
import MultiStack_List from '../MultiStackBar_List';
import MultiLine_List from '../MultiLineList';
import { userService } from '../../_services';
import { Redirect } from "react-router-dom";
import ColorJson from '../../../src/whitelabel.json';

class WholesalerDashboard extends React.Component {
    constructor(props) {
        super(props);
        var startdate = new Date();
        startdate.setDate(startdate.getDate() - 30);
        var enddate = new Date();
        if (localStorage.getItem('User_Start_Date') != "" && localStorage.getItem('User_Start_Date') != null && localStorage.getItem('User_Start_Date') != undefined) {
            startdate = localStorage.getItem('User_Start_Date');
        }
        if (localStorage.getItem('User_End_Date') != "" && localStorage.getItem('User_End_Date') != null && localStorage.getItem('User_End_Date') != undefined) {
            enddate = localStorage.getItem('User_End_Date');
        }

        let filterdatalocal = localStorage.getItem('Advance_Filter');
        if (filterdatalocal == null || filterdatalocal == '' || filterdatalocal == undefined || filterdatalocal == "null") {
            filterdatalocal = '';
        }
        var _roletype = '', _rolename = '';
        var _wh_Id = 0;
        try {
            var userdata = JSON.parse(localStorage.getItem('user'));
            if (userdata.userrole == "Distributor" && userdata.wholesaler == "Avenelllllll") {
                _roletype = "avdistributor";
                _rolename = userdata.email;
                _wh_Id = userdata.wholesaler_Id;
            }
            else if (userdata.userrole == "Distributor" && userdata.wholesaler != "Avenelllll") {
                _roletype = "distributor";
                _rolename = userdata.paramsname;
                _wh_Id = userdata.wholesaler_Id;
            }
            else {
                _roletype = userdata.userrole;
                _rolename = userdata.paramsname;
                _wh_Id = userdata.wholesaler_Id;
            }
        }
        catch (error) { }

        this.state = {
            userdata: JSON.parse(localStorage.getItem('user')),
            scrollArray: {},
            graphData: [],
            dashboardName: this.props.dashboardName,
            endDate: new moment(enddate).format("YYYYMMDD"),
            startDate: new moment(startdate).format("YYYYMMDD"),
            FilterTagMatch: [],
            FilterTagList: filterdatalocal,
            roletype: _roletype,
            rolename: _rolename,
            wh_Id: _wh_Id,
            dist_usertype: this.props.dist_usertype,
            prescribe_status: false
        };


        let newDate = new Date();
        localStorage.setItem('Filter_Last_Update_Time', newDate);
        this.handlechangea = this.handlechangea.bind(this);
        this.changeData();
    }
    componentDidMount() {
        this.changeData();
        setTimeout(function () {
            var $head = $(".widget-iframe").contents().find("head");
            var $body = $(".widget-iframe").contents().find("body");
            $head.append($("<link/>",
                { rel: "stylesheet", href: "/table.css", type: "text/css" }));
            if ($(window).width() < 480) {
                $body.addClass('scrollMobile');
            } else {
                $body.removeClass('scrollMobile');
            }

        }, 1000);
        $(window).resize(function () {
            var $body = $(".widget-iframe").contents().find("body");
            if ($(window).width() < 480) {
                $body.addClass('scrollMobile');
            } else {
                $body.removeClass('scrollMobile');
            }
        });
        $(".analytics-menu").click(e => {
            if ($('.collapseButton').hasClass("active")) {
                this.handleCollapse();
                $('.sidebar-submenu').show();
                $('body').toggleClass('sub-menu-active');
            }
        });
    }
    componentDidUpdate() {
        if (this.state.dist_usertype != this.props.dist_usertype) {
            this.setState({
                dist_usertype: this.props.dist_usertype
            });
            localStorage.setItem('dist_usertype', this.props.dist_usertype);
            this.changeData();
        }
    }
    handlechangea(e) {
        this.props.handeChangefilter(e);
    }


    handleCollapse = () => {
        if ($(".sidebar-section").hasClass("intro")) {
            $(".menu-text").css({ 'width': 'auto', 'overflow': 'visible' });
            $(".beta").css('width', 12 + 'px');
            $(".sidebar-section").animate({
                width: 270 + 'px'
            }, 1000);
            $(".collapseButton").animate({
                left: 246 + 'px'
            }, 1000, function () {
                $("#chartjs-tooltip").hide();
                $(".collapseButton").removeClass('active');
            });
            $(".dashboardHeading").animate({
                marginLeft: 313 + 'px'
            }, 400);
            $("#dashboard_header_select").animate({
                marginLeft: 0 + 'px'
            }, 1000);
            $("#dashboard-container").animate({
                marginLeft: 13 + 'px'
            }, 1000);
            $(".adjustWidth").css('margin', '0 0 0 65px');
            $(".sidebar-section").removeClass('intro');
            $(".react-bootstrap-daterangepicker-container").animate({
                marginRight: 0 + 'px'
            }, 1000);
            $("#dashboard_header_select").removeClass('full');
        } else {
            $(".sidebar-section").animate({
                width: 90 + 'px'
            }, 1000, function () {
                $(".menu-text").css({ 'width': '0px', 'overflow': 'hidden' });
                $('.sidebar-submenu').hide();
                if ($('body').hasClass("sub-menu-active")) {
                    $('body').toggleClass('sub-menu-active');
                }
            });
            $(".collapseButton").animate({
                left: 66 + 'px'
            }, 1000, function () {
                $(".collapseButton").addClass('active')
            });
            $(".dashboardHeading").animate({
                marginLeft: 140 + 'px'
            }, 400);
            $("#dashboard_header_select").animate({
                marginLeft: -173 + 'px'
            }, 1000);
            $(".react-bootstrap-daterangepicker-container").animate({
                marginRight: -173 + 'px'
            }, 1000, function () {
                $("#dashboard_header_select").addClass('full');
            });
            $("#dashboard-container").animate({
                marginLeft: -158 + 'px'
            }, 1000);
            $(".adjustWidth").css('margin', '0 auto');
            $(".sidebar-section").addClass('intro');
        }
        var $head8 = $(".widget-iframe").contents().find("head");
        $head8.append($("<link/>",
            { rel: "stylesheet", href: "/table.css", type: "text/css" }));
    }
    fetchPrescriberInfo() {
        try {
            let whid = this.state.userdata.wholesaler_Id.toString();
            userService.WhPrescribeInfo(whid).then(
                apidata => {
                    try {
                        if (apidata.length > 0) {
                            this.setState({ prescribe_status: apidata[0]._IsPrescribeData });
                        }
                    }
                    catch (error) {
                    }
                }
            );
        }
        catch (error) {
        }
    }

    changeData(dname, stdate, endate) {
        this.fetchPrescriberInfo();
        var APIBaseURL = "";
        var wname = '';
        var startDateObj = '';
        var endDateObj = '';
        var AllDirectOverride = this.props.dist_usertype;
        if (this.props == undefined) {
            wname = dname;
            startDateObj = stdate;
            endDateObj = endate;
        }
        else {
            wname = this.props.dashboardName;
            startDateObj = this.props.startDate;
            endDateObj = this.props.endDate;
        }

        //var wname = this.state.dashboardName;
        var startDate = new moment(startDateObj).format("YYYYMMDD");
        var endDate = new moment(endDateObj).format("YYYYMMDD");
        this.setState({ startDate: startDate });
        this.setState({ endDate: endDate });
        //if (escape(wname.replace(" Dashboard (wholesaler)", "").trim()) == 'Avenelllllllll') {
        //    APIBaseURL = '/api/avws';
        //}
        //else {
        if (AllDirectOverride === 'All')
            APIBaseURL = '/api/ws_All_Filter';
        else if (AllDirectOverride === 'Direct')
            APIBaseURL = '/api/ws';
        else if (AllDirectOverride === 'Override')
            APIBaseURL = '/api/ws_Override_Filter';
        else
            APIBaseURL = '/api/ws';
        //APIBaseURL = '/api/ws';
        //}
        let newDate = new Date();
        try {
            newDate = localStorage.getItem('Updated_Filter_Status');
        }
        catch (error) {
        }

        var AdFilterJson = '';
        try {
            AdFilterJson = JSON.parse(localStorage.getItem('Advance_Filter'))
            if (AdFilterJson != null && AdFilterJson != '' && AdFilterJson != undefined && AdFilterJson != "null") {
                this.setState({ FilterTagList: JSON.stringify(AdFilterJson) });
            }
            else {
                this.setState({ FilterTagList: '' });
            }
        }
        catch (error) {
            this.setState({ FilterTagList: '' });
        }

        var Request_user = escape(wname.replace(" Dashboard (wholesaler)", "").trim());
        //var Pie_Chart_RequestJson = "{\"wname\"" + ":\"" + Request_user + "\",\"start_date\"" + ":\"" + startDate + "\",\"end_date\"" + ":\"" + endDate + "\",\"rcount\"" + ":" + 30 + "}"
        var Column_PostData_RequestJson_Commission = "{\"wname\"" + ":\"" + this.state.userdata["wholesaler_Id"] + "\",\"start_date\"" + ":\"" + startDate + "\",\"end_date\"" + ":\"" + endDate + "\",\"rcount\"" + ":" + 0 + ",\"chart_type\"" + ":\"" + "columnlist_multiaxislist\"" + ",\"ispatientsaving\"" + ":\"" + "true\"" + ",\"pharmacynumber\"" + ":\"" + "all\"" + ",\"filtertime\"" + ":\"" + localStorage.getItem('Filter_Last_Update_Time') + "\",\"rxsClaimType\"" + ":\"" + localStorage.getItem('Updated_HD_Type') + "\",\"wholesaler_id\"" + ":\"" + this.state.userdata["wholesaler_Id"] + "\"}";
        var Column_PostData_RequestJson = "{\"wname\"" + ":\"" + this.state.userdata["wholesaler_Id"] + "\",\"start_date\"" + ":\"" + startDate + "\",\"end_date\"" + ":\"" + endDate + "\",\"rcount\"" + ":" + 30 + ",\"chart_type\"" + ":\"" + "columnList\"" + ",\"ispatientsaving\"" + ":\"" + "true\"" + ",\"pharmacynumber\"" + ":\"" + "all\"" + ",\"filtertime\"" + ":\"" + localStorage.getItem('Filter_Last_Update_Time') + "\",\"rxsClaimType\"" + ":\"" + localStorage.getItem('Updated_HD_Type') + "\",\"wholesaler_id\"" + ":\"" + this.state.userdata["wholesaler_Id"] + "\"}";
        var PostData_RequestJson = "{\"wname\"" + ":\"" + this.state.userdata["wholesaler_Id"] + "\",\"start_date\"" + ":\"" + startDate + "\",\"end_date\"" + ":\"" + endDate + "\",\"rcount\"" + ":" + 30 + ",\"chart_type\"" + ":\"" + "pielist\"" + ",\"filtertime\"" + ":\"" + localStorage.getItem('Filter_Last_Update_Time') + "\",\"rxsClaimType\"" + ":\"" + localStorage.getItem('Updated_HD_Type') + "\",\"wholesaler_id\"" + ":\"" + this.state.userdata["wholesaler_Id"] + "\"}";
        var PostData_PatientSaving_True = "{\"wname\"" + ":\"" + this.state.userdata["wholesaler_Id"] + "\",\"start_date\"" + ":\"" + startDate + "\",\"end_date\"" + ":\"" + endDate + "\",\"rcount\"" + ":" + 0 + ",\"chart_type\"" + ":\"" + "columnList\"" + ",\"ispatientsaving\"" + ":\"" + "true\"" + ",\"pharmacynumber\"" + ":\"" + "all\"" + ",\"filtertime\"" + ":\"" + localStorage.getItem('Filter_Last_Update_Time') + "\",\"rxsClaimType\"" + ":\"" + localStorage.getItem('Updated_HD_Type') + "\",\"wholesaler_id\"" + ":\"" + this.state.userdata["wholesaler_Id"] + "\"}";
        var PostData_PatientSaving_False = "{\"wname\"" + ":\"" + this.state.userdata["wholesaler_Id"] + "\",\"start_date\"" + ":\"" + startDate + "\",\"end_date\"" + ":\"" + endDate + "\",\"rcount\"" + ":" + 0 + ",\"chart_type\"" + ":\"" + "columnList\"" + ",\"ispatientsaving\"" + ":\"" + "false\"" + ",\"pharmacynumber\"" + ":\"" + "all\"" + ",\"filtertime\"" + ":\"" + localStorage.getItem('Filter_Last_Update_Time') + "\",\"rxsClaimType\"" + ":\"" + localStorage.getItem('Updated_HD_Type') + "\",\"wholesaler_id\"" + ":\"" + this.state.userdata["wholesaler_Id"] + "\"}";
        var PatientSavings_Pharmacy_RequestJson = "{\"wname\"" + ":\"" + this.state.userdata["wholesaler_Id"] + "\",\"start_date\"" + ":\"" + startDate + "\",\"end_date\"" + ":\"" + endDate + "\",\"rcount\"" + ":" + 30 + ",\"chart_type\"" + ":\"" + "list\"" + ",\"filtertime\"" + ":\"" + localStorage.getItem('Filter_Last_Update_Time') + "\",\"rxsClaimType\"" + ":\"" + localStorage.getItem('Updated_HD_Type') + "\",\"wholesaler_id\"" + ":\"" + this.state.userdata["wholesaler_Id"] + "\"}";
        var Table_Pharmacy_RequestJson = "{\"wname\"" + ":\"" + this.state.userdata["wholesaler_Id"] + "\",\"start_date\"" + ":\"" + startDate + "\",\"end_date\"" + ":\"" + endDate + "\",\"rcount\"" + ":" + 30 + ",\"chart_type\"" + ":\"" + "list\"" + ",\"filtertime\"" + ":\"" + localStorage.getItem('Filter_Last_Update_Time') + "\",\"rxsClaimType\"" + ":\"" + localStorage.getItem('Updated_HD_Type') + "\",\"wholesaler_id\"" + ":\"" + this.state.userdata["wholesaler_Id"] + "\"}";
        var Table_Repeat_Prescriptions_RequestJson = "{\"wname\"" + ":\"" + this.state.userdata["wholesaler_Id"] + "\",\"start_date\"" + ":\"" + startDate + "\",\"end_date\"" + ":\"" + endDate + "\",\"rcount\"" + ":" + 30 + ",\"chart_type\"" + ":\"" + "list\"" + ",\"filtertime\"" + ":\"" + localStorage.getItem('Filter_Last_Update_Time') + "\",\"rxsClaimType\"" + ":\"" + localStorage.getItem('Updated_HD_Type') + "\",\"wholesaler_id\"" + ":\"" + this.state.userdata["wholesaler_Id"] + "\"}";
        var TotalTransaction_PostData_RequestJson = "{\"wname\"" + ":\"" + this.state.userdata["wholesaler_Id"] + "\",\"start_date\"" + ":\"" + startDate + "\",\"end_date\"" + ":\"" + endDate + "\",\"rcount\"" + ":" + 0 + ",\"chart_type\"" + ":\"" + "columnList\"" + ",\"ispatientsaving\"" + ":\"" + "true\"" + ",\"pharmacynumber\"" + ":\"" + "all\"" + ",\"filtertime\"" + ":\"" + localStorage.getItem('Filter_Last_Update_Time') + "\",\"rxsClaimType\"" + ":\"" + localStorage.getItem('Updated_HD_Type') + "\",\"wholesaler_id\"" + ":\"" + this.state.userdata["wholesaler_Id"] + "\"}";

        var Claim_PostData_RequestJson = "{\"wname\"" + ":\"" + this.state.userdata["wholesaler_Id"] + "\",\"start_date\"" + ":\"" + startDate + "\",\"end_date\"" + ":\"" + endDate + "\",\"rcount\"" + ":" + 0 + ",\"chart_type\"" + ":\"" + "list\"" + ",\"filtertime\"" + ":\"" + localStorage.getItem('Filter_Last_Update_Time') + "\",\"rxsClaimType\"" + ":\"" + localStorage.getItem('Updated_HD_Type') + "\",\"wholesaler_id\"" + ":\"" + this.state.userdata["wholesaler_Id"] + "\"}";
        var MultiAxis_Column_PostData_RequestJson = "{\"wname\"" + ":\"" + this.state.userdata["wholesaler_Id"] + "\",\"start_date\"" + ":\"" + startDate + "\",\"end_date\"" + ":\"" + endDate + "\",\"rcount\"" + ":" + 0 + ",\"chart_type\"" + ":\"" + "column_multiaxislist\"" + ",\"ispatientsaving\"" + ":\"" + "true\"" + ",\"pharmacynumber\"" + ":\"" + "all\"" + ",\"filtertime\"" + ":\"" + localStorage.getItem('Filter_Last_Update_Time') + "\",\"rxsClaimType\"" + ":\"" + localStorage.getItem('Updated_HD_Type') + "\"}";
        var MultiLine_PostData_RequestJson = "{\"wname\"" + ":\"" + this.state.userdata["wholesaler_Id"] + "\",\"start_date\"" + ":\"" + startDate + "\",\"end_date\"" + ":\"" + endDate + "\",\"rcount\"" + ":" + 0 + ",\"chart_type\"" + ":\"" + "multilinelist\"" + ",\"ispatientsaving\"" + ":\"" + "true\"" + ",\"pharmacynumber\"" + ":\"" + "all\"" + ",\"filtertime\"" + ":\"" + localStorage.getItem('Filter_Last_Update_Time') + "\",\"rxsClaimType\"" + ":\"" + localStorage.getItem('Updated_HD_Type') + "\"}";
        var primaryColor;
        var secondaryColor;
        var extraColor;
        if (window.location.host.split('.').slice(-2).join('.').toLowerCase() == "rxhacker.com" || window.location.host.split('.').slice(-2).join('.').toLowerCase() == "localhost:5464" || window.location.host.toLowerCase() == "tempfilter-dev.glichealth.com" || window.location.host.toLowerCase() == "reporting.nulifespanrx.com") {
            primaryColor = ColorJson.ApplicationColor.Rxhacker_primary_color;
            secondaryColor = ColorJson.ApplicationColor.Rxhacker_secondary_color;
            extraColor = ColorJson.ApplicationColor.Rxhacker_extra_color;
        } else {
            primaryColor = ColorJson.ApplicationColor.Glic_primary_color;
            secondaryColor = ColorJson.ApplicationColor.Glic_secondary_color;
            extraColor = ColorJson.ApplicationColor.Glic_extra_color;
        }

        if (this.state.userdata.isLegacyUser == true) {
            this.setState({
                dashboardName: wname,
                graphData: [
                    {
                        //url: APIBaseURL + "ws/totaltransaction?wname=" + escape(wname.replace(" Dashboard (wholesaler)", "").trim()) + "&start_date=" + startDate + "&end_date=" + endDate,
                        url: APIBaseURL + "/totlal_transactions_new",
                        type: "Bar_List",
                        title: "Total Transactions",
                        Subtitle: "Total number of transactions for each day",
                        ColorCode: secondaryColor,
                        DataType: "NA",
                        XlabelString: "Date",
                        YlabelString: "# of Transactions",
                        interval: 'day',
                        id: "WTotalTransaction",
                        RequestJson: TotalTransaction_PostData_RequestJson,
                        RequestJson1: JSON.stringify(AdFilterJson)
                    },
                    {
                        url: APIBaseURL + "/ClaimCalculation",
                        type: "Claim",
                        title: "Claim Counts",
                        Subtitle: "",
                        ColorCode: extraColor,
                        id: "RxSensClaim",
                        RequestJson: Claim_PostData_RequestJson,
                        RequestJson1: JSON.stringify(AdFilterJson)
                    },
                    //{
                    //    url: APIBaseURL + "/new_and_repeat_claims",
                    //    type: "MultiBar_List2",
                    //    title: "New vs Repeat Transactions",
                    //    Subtitle: "New vs Repeat Compensable Transactions",
                    //    ColorCode: primaryColor,
                    //    DataType: "NA",
                    //    interval: 'day',
                    //    XlabelString: "Date",
                    //    YlabelString: "# of Transactions",
                    //    id: "new_repeat_widget",
                    //    BorderRadius: 0,
                    //    RequestJson: MultiAxis_Column_PostData_RequestJson,
                    //    RequestJson1: JSON.stringify(AdFilterJson)
                    //},
                    {
                        url: APIBaseURL + "/new_and_repeat_claims_Line",
                        type: "MultiLine_List",
                        title: "New vs Repeat Transactions",
                        Subtitle: "New vs Repeat Compensable Transactions",
                        ColorCode: primaryColor,
                        DataType: "NA",
                        interval: 'day',
                        XlabelString: "Date",
                        YlabelString: "# of Transactions",
                        id: "new_repeat_widget_Line",
                        BorderRadius: 0,
                        RequestJson: MultiLine_PostData_RequestJson,
                        RequestJson1: JSON.stringify(AdFilterJson)
                    },
                    //{
                    //    url: APIBaseURL + "/ClaimCalculationNew",
                    //    type: "Claim_New",
                    //    title: "Claim Counts",
                    //    Subtitle: "",
                    //    ColorCode: "#ffba10",
                    //    id: "RxSensClaimNew",
                    //    RequestJson: Claim_PostData_RequestJson,
                    //    RequestJson1: JSON.stringify(AdFilterJson)
                    //},
                    {
                        //url: APIBaseURL + "ws/metric1a?rcount=30&wname=" + escape(wname.replace(" Dashboard (wholesaler)", "").trim()) + "&start_date=" + startDate + "&end_date=" + endDate,
                        url: APIBaseURL + "/metric1a_new",
                        type: "Bar_List",
                        title: "Transactions by Group Number",
                        Subtitle: "Number of transactions for each group number",
                        ColorCode: secondaryColor,
                        DataType: "GroupNumber",
                        XlabelString: "Group Number",
                        YlabelString: "# of Transactions",
                        id: "WMetric1a",
                        RequestJson: Column_PostData_RequestJson,
                        RequestJson1: JSON.stringify(AdFilterJson)
                    },
                    //{
                    //    //url: APIBaseURL + "ws/metric1b?wname=" + escape(wname.replace(" Dashboard (wholesaler)", "").trim()) + "&ispatientsaving=true&pharmacynumber=all&start_date=" + startDate + "&end_date=" + endDate,
                    //    url: APIBaseURL + "/patient_savings_new",
                    //    type: "Bar_List",
                    //    title: "Average Patient Savings ($)",
                    //    Subtitle: "Average savings for all patients in $",
                    //    ColorCode: "#2A524B",
                    //    DataType: "NA",
                    //    XlabelString: "Date",
                    //    YlabelString: "Average Savings",
                    //    id: "WMetric3A",
                    //    RequestJson: PostData_PatientSaving_True,
                    //    RequestJson1: JSON.stringify(AdFilterJson)
                    //},
                    {
                        //url: APIBaseURL + "ws/metric1b?wname=" + escape(wname.replace(" Dashboard (wholesaler)", "").trim()) + "&ispatientsaving=false&pharmacynumber=all&start_date=" + startDate + "&end_date=" + endDate,
                        url: APIBaseURL + "/patient_savings_new",
                        type: "Bar_List",
                        title: "Total Patient Savings ($)",
                        Subtitle: "Total savings for all patients in $",
                        ColorCode: secondaryColor,
                        DataType: "NA",
                        XlabelString: "Date",
                        YlabelString: "Total Savings",
                        id: "WMetric3B",
                        RequestJson: PostData_PatientSaving_True,
                        RequestJson1: JSON.stringify(AdFilterJson)
                    },
                    //{
                    //    //url: APIBaseURL + "ws/top20pharmacy?wname=" + escape(wname.replace(" Dashboard (wholesaler)", "").trim()) + "&start_date=" + startDate + "&end_date=" + endDate,
                    //    url: APIBaseURL +"/top20avgsavingspharmacy_new",
                    //    type: "Column_Pie",
                    //    title: "Average Patient Savings at Top 20 Pharmacies",
                    //    Subtitle: "Shows the average savings at the top 20 pharmacies",
                    //    ColorCode: "#ffba10",
                    //    XlabelString: "Pharmacy",
                    //    YlabelString: "Average Saving",
                    //    id: "WTop20pharmacy",
                    //    RequestJson: PostData_RequestJson
                    //},
                    //{
                    //    //url: APIBaseURL + "ws/wholesalertransaction?wname=" + escape(wname.replace(" Dashboard (wholesaler)", "").trim()) + "&start_date=" + startDate + "&end_date=" + endDate,
                    //    url: APIBaseURL +"/wholesalertransaction_new",
                    //    type: "List",
                    //    title: "Number of Transactions (combine widget 1)",
                    //    Subtitle: "Number of Transactions",
                    //    ColorCode: "#ffba10",
                    //    XlabelString: "",
                    //    YlabelString: "",
                    //    id: "WWholesalerTransaction",
                    //    RequestJson:Table_Pharmacy_RequestJson
                    //},
                    //{
                    //    url: APIBaseURL + "/citytransaction_new",
                    //    type: "Column_Pie",
                    //    title: "Transactions by City",
                    //    Subtitle: "Number of transactions in each city",
                    //    XlabelString: "",
                    //    YlabelString: "",
                    //    ColorCode: "#ffba10",
                    //    DataType: "PhCity",
                    //    id: "CityTransaction",
                    //    RequestJson: PostData_RequestJson,
                    //    RequestJson1: JSON.stringify(AdFilterJson)
                    //},

                    //{
                    //    //url: APIBaseURL + "ws/pharmacytransaction1?wname=" + escape(wname.replace(" Dashboard (wholesaler)", "").trim()) + "&start_date=" + startDate + "&end_date=" + endDate,
                    //    url: APIBaseURL + "/pharmacy_transaction_new",
                    //    type: "List",
                    //    title: "Transactions by Pharmacy",
                    //    Subtitle: "Number of transactions at each pharmacy",
                    //    ColorCode: "#ffba10",
                    //    XlabelString: "",
                    //    YlabelString: "",
                    //    id: "WPharmacyTransaction1",
                    //    RequestJson: Table_Pharmacy_RequestJson,
                    //    RequestJson1: JSON.stringify(AdFilterJson)
                    //},
                    //{
                    //    //url: APIBaseURL + "ws/statetransaction?wname=" + escape(wname.replace(" Dashboard (wholesaler)", "").trim()) + "&start_date=" + startDate + "&end_date=" + endDate,
                    //    url: APIBaseURL + "/statetransaction_new",
                    //    type: "Column_Pie",
                    //    title: "Transactions by State",
                    //    Subtitle: "Number of transactions in each state",
                    //    XlabelString: "States",
                    //    YlabelString: "Number of Transactions",
                    //    ColorCode: "#ffba10",
                    //    DataType: "PhState",
                    //    id: "WStateTransaction",
                    //    RequestJson: PostData_RequestJson,
                    //    RequestJson1: JSON.stringify(AdFilterJson)
                    //},
                    //{
                    //    //url: APIBaseURL + "ws/patientsavingtransaction?wname=" + escape(wname.replace(" Dashboard (wholesaler)", "").trim()) + "&start_date=" + startDate + "&end_date=" + endDate,
                    //    url: APIBaseURL + "/patientsavings_new",
                    //    type: "List",
                    //    title: "Patient Savings by Pharmacy",
                    //    Subtitle: "Patient savings in $ at each pharmacy",
                    //    ColorCode: "#ffba10",
                    //    XlabelString: "",
                    //    YlabelString: "",
                    //    id: "WPatientSavingTransaction",
                    //    RequestJson: PatientSavings_Pharmacy_RequestJson,
                    //    RequestJson1: JSON.stringify(AdFilterJson)
                    //},
                    {
                        //url: APIBaseURL + "ws/drugtransaction?wname=" + escape(wname.replace(" Dashboard (wholesaler)", "").trim()) + "&start_date=" + startDate + "&end_date=" + endDate,
                        url: APIBaseURL + "/drugtransaction_new",
                        type: "Column_Pie",
                        title: "Transactions by Drug",
                        Subtitle: "Number of transactions for each drug",
                        ColorCode: extraColor,
                        DataType: "DrugName",
                        id: "WDrugTransaction",
                        RequestJson: PostData_RequestJson,
                        RequestJson1: JSON.stringify(AdFilterJson)
                    },
                    //{
                    //    // url: APIBaseURL + "/ws/commission?wname=" + escape(wname.replace(" Dashboard (wholesaler)", "").trim()),
                    //    url: APIBaseURL + "/commission_new",
                    //    type: "Bar_List",
                    //    title: "Total Commission Earned",
                    //    Subtitle: "Commission earned for each month",
                    //    ColorCode: "#2A524B",
                    //    DataType: "NA",
                    //    XlabelString: "Date",
                    //    YlabelString: "Commission",
                    //    interval: 'month',
                    //    id: "WCommission",
                    //    RequestJson: Column_PostData_RequestJson_Commission,
                    //    RequestJson1: JSON.stringify(AdFilterJson)
                    //},
                    {
                        // url: APIBaseURL + "/ws/commission?wname=" + escape(wname.replace(" Dashboard (wholesaler)", "").trim()),
                        url: APIBaseURL + "/commission_new",
                        type: "MultiBar_List",
                        title: "Total Revenue Earned",
                        Subtitle: "Revenue earned for each month",
                        ColorCode: primaryColor,
                        DataType: "NA",
                        XlabelString: "Date",
                        YlabelString: "Commission",
                        interval: 'month',
                        id: "WCommission",
                        RequestJson: MultiAxis_Column_PostData_RequestJson,
                        RequestJson1: JSON.stringify(AdFilterJson)
                    },
                    {
                        //url: APIBaseURL + "ws/pharmacytransaction1?wname=" + escape(wname.replace(" Dashboard (wholesaler)", "").trim()) + "&start_date=" + startDate + "&end_date=" + endDate,
                        url: APIBaseURL + "/prescribe_transaction_new",
                        type: "List",
                        title: "Transactions by Prescriber",
                        Subtitle: "Number of transactions at each Prescriber",
                        ColorCode: "#ffba10",
                        XlabelString: "",
                        YlabelString: "",
                        id: "WPrescriberTransaction1",
                        RequestJson: Table_Pharmacy_RequestJson,
                        RequestJson1: JSON.stringify(AdFilterJson)
                    },
                    //{
                    //    //url: APIBaseURL + "ws/pharmacytransaction1?wname=" + escape(wname.replace(" Dashboard (wholesaler)", "").trim()) + "&start_date=" + startDate + "&end_date=" + endDate,
                    //    url: APIBaseURL + "/Repeat_Prescriptions_transaction_new",
                    //    type: "List",
                    //    title: "Repeat Prescriptions",
                    //    Subtitle: "Number of repeat prescriptions for each Prescriber",
                    //    ColorCode: "#ffba10",
                    //    XlabelString: "",
                    //    YlabelString: "",
                    //    id: "WRepeat_PrescriptionsTransaction",
                    //    RequestJson: Table_Repeat_Prescriptions_RequestJson,
                    //    RequestJson1: JSON.stringify(AdFilterJson)
                    //}
                    , {
                        //url: APIBaseURL + "ws/totaltransaction?wname=" + escape(wname.replace(" Dashboard (wholesaler)", "").trim()) + "&start_date=" + startDate + "&end_date=" + endDate,
                        url: APIBaseURL + "/unique_Members_Widget",
                        type: "Bar_List",
                        title: "Unique Member ID's",
                        Subtitle: "Number of unique members transacted on each day",
                        ColorCode: secondaryColor,
                        DataType: "NA",
                        XlabelString: "Date",
                        YlabelString: "# of Unique Member ID's",
                        interval: 'day',
                        id: "WUniqueMemberID",
                        RequestJson: TotalTransaction_PostData_RequestJson,
                        RequestJson1: JSON.stringify(AdFilterJson)
                    }
                ]
            });
        }
        else {
            this.setState({
                dashboardName: wname,
                graphData: [
                    {
                        //url: APIBaseURL + "ws/totaltransaction?wname=" + escape(wname.replace(" Dashboard (wholesaler)", "").trim()) + "&start_date=" + startDate + "&end_date=" + endDate,
                        url: APIBaseURL + "/totlal_transactions_new",
                        type: "Bar_List",
                        title: "Total Transactions",
                        Subtitle: "Total number of transactions for each day",
                        ColorCode: secondaryColor,
                        DataType: "NA",
                        XlabelString: "Date",
                        YlabelString: "# of Transactions",
                        interval: 'day',
                        id: "WTotalTransaction",
                        RequestJson: TotalTransaction_PostData_RequestJson,
                        RequestJson1: JSON.stringify(AdFilterJson)
                    },
                    //{
                    //    url: APIBaseURL + "/new_and_repeat_claims",
                    //    type: "MultiBar_List2",
                    //    title: "New vs Repeat Transactions",
                    //    Subtitle: "New vs Repeat Compensable Transactions",
                    //    ColorCode: primaryColor,
                    //    DataType: "NA",
                    //    interval: 'day',
                    //    XlabelString: "Date",
                    //    YlabelString: "# of Transactions",
                    //    id: "new_repeat_widget",
                    //    BorderRadius: 0,
                    //    RequestJson: MultiAxis_Column_PostData_RequestJson,
                    //    RequestJson1: JSON.stringify(AdFilterJson)
                    //},
                    {
                        url: APIBaseURL + "/new_and_repeat_claims_Line",
                        type: "MultiLine_List",
                        title: "New vs Repeat Transactions",
                        Subtitle: "New vs Repeat Compensable Transactions",
                        ColorCode: primaryColor,
                        DataType: "NA",
                        interval: 'day',
                        XlabelString: "Date",
                        YlabelString: "# of Transactions",
                        id: "new_repeat_widget_Line",
                        BorderRadius: 0,
                        RequestJson: MultiLine_PostData_RequestJson,
                        RequestJson1: JSON.stringify(AdFilterJson)
                    },
                    //{
                    //    url: APIBaseURL + "/ClaimCalculation",
                    //    type: "Claim",
                    //    title: "Claim Counts",
                    //    Subtitle: "",
                    //    ColorCode: "#ffba10",
                    //    id: "RxSensClaim",
                    //    RequestJson: Claim_PostData_RequestJson,
                    //    RequestJson1: JSON.stringify(AdFilterJson)
                    //},
                    //{
                    //    url: APIBaseURL + "/ClaimCalculationNew",
                    //    type: "Claim_New",
                    //    title: "Claim Counts",
                    //    Subtitle: "",
                    //    ColorCode: "#ffba10",
                    //    id: "RxSensClaimNew",
                    //    RequestJson: Claim_PostData_RequestJson,
                    //    RequestJson1: JSON.stringify(AdFilterJson)
                    //},
                    {
                        //url: APIBaseURL + "ws/metric1a?rcount=30&wname=" + escape(wname.replace(" Dashboard (wholesaler)", "").trim()) + "&start_date=" + startDate + "&end_date=" + endDate,
                        url: APIBaseURL + "/metric1a_new",
                        type: "Bar_List",
                        title: "Transactions by Group Number",
                        Subtitle: "Number of transactions for each group number",
                        ColorCode: secondaryColor,
                        DataType: "GroupNumber",
                        XlabelString: "Group Number",
                        YlabelString: "# of Transactions",
                        id: "WMetric1a",
                        RequestJson: Column_PostData_RequestJson,
                        RequestJson1: JSON.stringify(AdFilterJson)
                    },
                    //{
                    //    //url: APIBaseURL + "ws/metric1b?wname=" + escape(wname.replace(" Dashboard (wholesaler)", "").trim()) + "&ispatientsaving=true&pharmacynumber=all&start_date=" + startDate + "&end_date=" + endDate,
                    //    url: APIBaseURL + "/patient_savings_new",
                    //    type: "Bar_List",
                    //    title: "Average Patient Savings ($)",
                    //    Subtitle: "Average savings for all patients in $",
                    //    ColorCode: "#2A524B",
                    //    DataType: "NA",
                    //    XlabelString: "Date",
                    //    YlabelString: "Average Savings",
                    //    id: "WMetric3A",
                    //    RequestJson: PostData_PatientSaving_True,
                    //    RequestJson1: JSON.stringify(AdFilterJson)
                    //},
                    {
                        //url: APIBaseURL + "ws/metric1b?wname=" + escape(wname.replace(" Dashboard (wholesaler)", "").trim()) + "&ispatientsaving=false&pharmacynumber=all&start_date=" + startDate + "&end_date=" + endDate,
                        url: APIBaseURL + "/patient_savings_new",
                        type: "Bar_List",
                        title: "Total Patient Savings ($)",
                        Subtitle: "Total savings for all patients in $",
                        ColorCode: secondaryColor,
                        DataType: "NA",
                        XlabelString: "Date",
                        YlabelString: "Total Savings",
                        id: "WMetric3B",
                        RequestJson: PostData_PatientSaving_True,
                        RequestJson1: JSON.stringify(AdFilterJson)
                    },
                    //{
                    //    //url: APIBaseURL + "ws/top20pharmacy?wname=" + escape(wname.replace(" Dashboard (wholesaler)", "").trim()) + "&start_date=" + startDate + "&end_date=" + endDate,
                    //    url: APIBaseURL +"/top20avgsavingspharmacy_new",
                    //    type: "Column_Pie",
                    //    title: "Average Patient Savings at Top 20 Pharmacies",
                    //    Subtitle: "Shows the average savings at the top 20 pharmacies",
                    //    ColorCode: "#ffba10",
                    //    XlabelString: "Pharmacy",
                    //    YlabelString: "Average Saving",
                    //    id: "WTop20pharmacy",
                    //    RequestJson: PostData_RequestJson
                    //},
                    //{
                    //    //url: APIBaseURL + "ws/wholesalertransaction?wname=" + escape(wname.replace(" Dashboard (wholesaler)", "").trim()) + "&start_date=" + startDate + "&end_date=" + endDate,
                    //    url: APIBaseURL +"/wholesalertransaction_new",
                    //    type: "List",
                    //    title: "Number of Transactions (combine widget 1)",
                    //    Subtitle: "Number of Transactions",
                    //    ColorCode: "#ffba10",
                    //    XlabelString: "",
                    //    YlabelString: "",
                    //    id: "WWholesalerTransaction",
                    //    RequestJson:Table_Pharmacy_RequestJson
                    //},
                    //{
                    //    url: APIBaseURL + "/citytransaction_new",
                    //    type: "Column_Pie",
                    //    title: "Transactions by City",
                    //    Subtitle: "Number of transactions in each city",
                    //    XlabelString: "",
                    //    YlabelString: "",
                    //    ColorCode: "#ffba10",
                    //    DataType: "PhCity",
                    //    id: "CityTransaction",
                    //    RequestJson: PostData_RequestJson,
                    //    RequestJson1: JSON.stringify(AdFilterJson)
                    //},

                    //{
                    //    //url: APIBaseURL + "ws/pharmacytransaction1?wname=" + escape(wname.replace(" Dashboard (wholesaler)", "").trim()) + "&start_date=" + startDate + "&end_date=" + endDate,
                    //    url: APIBaseURL + "/pharmacy_transaction_new",
                    //    type: "List",
                    //    title: "Transactions by Pharmacy",
                    //    Subtitle: "Number of transactions at each pharmacy",
                    //    ColorCode: "#ffba10",
                    //    XlabelString: "",
                    //    YlabelString: "",
                    //    id: "WPharmacyTransaction1",
                    //    RequestJson: Table_Pharmacy_RequestJson,
                    //    RequestJson1: JSON.stringify(AdFilterJson)
                    //},
                    //{
                    //    //url: APIBaseURL + "ws/statetransaction?wname=" + escape(wname.replace(" Dashboard (wholesaler)", "").trim()) + "&start_date=" + startDate + "&end_date=" + endDate,
                    //    url: APIBaseURL + "/statetransaction_new",
                    //    type: "Column_Pie",
                    //    title: "Transactions by State",
                    //    Subtitle: "Number of transactions in each state",
                    //    XlabelString: "States",
                    //    YlabelString: "Number of Transactions",
                    //    ColorCode: "#ffba10",
                    //    DataType: "PhState",
                    //    id: "WStateTransaction",
                    //    RequestJson: PostData_RequestJson,
                    //    RequestJson1: JSON.stringify(AdFilterJson)
                    //},
                    //{
                    //    //url: APIBaseURL + "ws/patientsavingtransaction?wname=" + escape(wname.replace(" Dashboard (wholesaler)", "").trim()) + "&start_date=" + startDate + "&end_date=" + endDate,
                    //    url: APIBaseURL + "/patientsavings_new",
                    //    type: "List",
                    //    title: "Patient Savings by Pharmacy",
                    //    Subtitle: "Patient savings in $ at each pharmacy",
                    //    ColorCode: "#ffba10",
                    //    XlabelString: "",
                    //    YlabelString: "",
                    //    id: "WPatientSavingTransaction",
                    //    RequestJson: PatientSavings_Pharmacy_RequestJson,
                    //    RequestJson1: JSON.stringify(AdFilterJson)
                    //},
                    {
                        //url: APIBaseURL + "ws/drugtransaction?wname=" + escape(wname.replace(" Dashboard (wholesaler)", "").trim()) + "&start_date=" + startDate + "&end_date=" + endDate,
                        url: APIBaseURL + "/drugtransaction_new",
                        type: "Column_Pie",
                        title: "Transactions by Drug",
                        Subtitle: "Number of transactions for each drug",
                        ColorCode: extraColor,
                        DataType: "DrugName",
                        id: "WDrugTransaction",
                        RequestJson: PostData_RequestJson,
                        RequestJson1: JSON.stringify(AdFilterJson)
                    },
                    //{
                    //    // url: APIBaseURL + "/ws/commission?wname=" + escape(wname.replace(" Dashboard (wholesaler)", "").trim()),
                    //    url: APIBaseURL + "/commission_new",
                    //    type: "Bar_List",
                    //    title: "Total Commission Earned",
                    //    Subtitle: "Commission earned for each month",
                    //    ColorCode: "#2A524B",
                    //    DataType: "NA",
                    //    XlabelString: "Date",
                    //    YlabelString: "Commission",
                    //    interval: 'month',
                    //    id: "WCommission",
                    //    RequestJson: Column_PostData_RequestJson_Commission,
                    //    RequestJson1: JSON.stringify(AdFilterJson)
                    //},
                    {
                        // url: APIBaseURL + "/ws/commission?wname=" + escape(wname.replace(" Dashboard (wholesaler)", "").trim()),
                        url: APIBaseURL + "/commission_new",
                        type: "MultiBar_List",
                        title: "Total Revenue Earned",
                        Subtitle: "Revenue earned for each month",
                        ColorCode: primaryColor,
                        DataType: "NA",
                        XlabelString: "Date",
                        YlabelString: "Commission",
                        interval: 'month',
                        id: "WCommission",
                        RequestJson: MultiAxis_Column_PostData_RequestJson,
                        RequestJson1: JSON.stringify(AdFilterJson)
                    }
                    ,{
                        //url: APIBaseURL + "ws/pharmacytransaction1?wname=" + escape(wname.replace(" Dashboard (wholesaler)", "").trim()) + "&start_date=" + startDate + "&end_date=" + endDate,
                        url: APIBaseURL + "/prescribe_transaction_new",
                        type: "List",
                        title: "Transactions by Prescriber",
                        Subtitle: "Number of transactions at each Prescriber",
                        ColorCode: "#ffba10",
                        XlabelString: "",
                        YlabelString: "",
                        id: "WPrescriberTransaction1",
                        RequestJson: Table_Pharmacy_RequestJson,
                        RequestJson1: JSON.stringify(AdFilterJson)
                    },
                    //{
                    //    //url: APIBaseURL + "ws/pharmacytransaction1?wname=" + escape(wname.replace(" Dashboard (wholesaler)", "").trim()) + "&start_date=" + startDate + "&end_date=" + endDate,
                    //    url: APIBaseURL + "/Repeat_Prescriptions_transaction_new",
                    //    type: "List",
                    //    title: "Repeat Prescriptions",
                    //    Subtitle: "Number of repeat prescriptions for each Prescriber",
                    //    ColorCode: "#ffba10",
                    //    XlabelString: "",
                    //    YlabelString: "",
                    //    id: "WRepeat_PrescriptionsTransaction",
                    //    RequestJson: Table_Repeat_Prescriptions_RequestJson,
                    //    RequestJson1: JSON.stringify(AdFilterJson)
                    //}
                    , {
                        //url: APIBaseURL + "ws/totaltransaction?wname=" + escape(wname.replace(" Dashboard (wholesaler)", "").trim()) + "&start_date=" + startDate + "&end_date=" + endDate,
                        url: APIBaseURL + "/unique_Members_Widget",
                        type: "Bar_List",
                        title: "Unique Member ID's",
                        Subtitle: "Number of unique members transacted on each day",
                        ColorCode: secondaryColor,
                        DataType: "NA",
                        XlabelString: "Date",
                        YlabelString: "# of Unique Member ID's",
                        interval: 'day',
                        id: "WUniqueMemberID",
                        RequestJson: TotalTransaction_PostData_RequestJson,
                        RequestJson1: JSON.stringify(AdFilterJson)
                    }
                ]
            });
        }
    }

    render() {
        var APIBaseURL = "";
        var startDateObj = this.props.startDate;
        var startDate = new moment(startDateObj).format("YYYYMMDD");
        var endDateObj = this.props.endDate;
        var endDate = new moment(endDateObj).format("YYYYMMDD");
        var IsCall = false;

        try {

            if ((localStorage.getItem('Prev_Filter_Status').toLowerCase() != localStorage.getItem('Updated_Filter_Status').toLowerCase()) || (localStorage.getItem('Prev_AdFilter_Status') != localStorage.getItem('Updated_AdFilter_Status')) || (localStorage.getItem('Updated_HD_Type') != localStorage.getItem('Prev_HD_Type'))) {
                IsCall = true;
            }
            else {
                IsCall = false;
            }
        }
        catch (error) {
            IsCall = false;
        }
        try {
            if (endDate != this.state.endDate || startDate != this.state.startDate || IsCall == true) {
                if (IsCall == true) {
                    localStorage.setItem('Prev_Filter_Status', localStorage.getItem('Updated_Filter_Status'));
                    if (localStorage.getItem('Updated_AdFilter_Status') == "null" || localStorage.getItem('Updated_AdFilter_Status') == null) {
                        localStorage.setItem('Prev_AdFilter_Status', null);
                        localStorage.setItem('Updated_AdFilter_Status', null);
                    }
                    else {
                        localStorage.setItem('Prev_AdFilter_Status', localStorage.getItem('Updated_AdFilter_Status'));
                    }
                    if (localStorage.getItem('Updated_HD_Type') == "null" || localStorage.getItem('Updated_HD_Type') == null) {
                        localStorage.setItem('Prev_HD_Type', null);
                        localStorage.setItem('Updated_HD_Type', null);
                    }
                    else {
                        localStorage.setItem('Prev_HD_Type', localStorage.getItem('Updated_HD_Type'));
                    }
                }
                this.changeData();
            }
        } catch (error) {
        }

        const a = [];
        // eslint-disable-next-line no-unused-expressions
        a[0] = { height: 570, width: 1100 },
            a[1] = { height: 170, width: 550 },
            a[2] = { height: 170, width: 550 }

        try {
            let usertype = userService.Get_User_Type();
            if (userService.Check_LoggedIn_Status() == 'Login') {
                return <Redirect to="/login" />
            }
            if (usertype.toLowerCase() == 'admin') {
                return <Redirect to='/pageNotFound' />
            }
            else if (usertype.toLowerCase() == 'distributor') {
                return <Redirect to='/pageNotFound' />
            }
            else if (usertype.toLowerCase() == 'subadmin') {
                return <Redirect to='/pageNotFound' />
            }
        } catch (error) { }

        return (
            <div className={this.state.userdata.isLegacyUser == false ? "dashboard-content-parent legacy" : "dashboard-content-parent"}>
                <div className="newBoard">
                    <div className="parent">
                        <div className="contentContainer">
                            <div>
                                <div className='row'>
                                    <div className='double-column'>
                                        <div className="dashboard-container" id="dashboard-container">

                                            <a href="javascript:void('0')" className="collapseButton" onClick={this.handleCollapse}>Collapse Button</a>

                                            <FilterTagCom Rolename={this.state.rolename} wh_Id={this.state.wh_Id} Roletype={this.state.roletype} df={this.state.startDate} dt={this.state.endDate} handlechangea={this.handlechangea} FilterTags={this.state.FilterTagList} Loading={true} />

                                            {
                                                this.state.graphData.map((item, index, id) => {
                                                    var k = null;
                                                    return (
                                                        /*((this.state.dashboardName.replace(" Dashboard (wholesaler)", "").toLowerCase() == 'patient rx discount' && item.title == 'Transactions by Prescriber') || (this.state.dashboardName.replace(" Dashboard (wholesaler)", "").toLowerCase() != 'patient rx discount' && item.title == "Unique Member ID's")) ? null :*/
                                                        ((this.state.dashboardName.replace(" Dashboard (wholesaler)", "").toLowerCase() != 'patient rx discount' && item.title == "Unique Member ID's") && (this.state.dashboardName.replace(" Dashboard (wholesaler)", "").toLowerCase() != 'id.me' && item.title == "Unique Member ID's") || (this.state.prescribe_status == false && item.title == "Transactions by Prescriber")) ? null :
                                                            <div id={item.id + index} className={`${item.type == "Bar" ? "widget ui-draggable ui-resizable" : item.type == "Line" ? "widget ui-draggable ui-resizable second" : "widget ui-draggable ui-resizable customScroll third"}${item.id == "WTotalTransaction" ? ' full-layout barlist' : ''}${item.id == "new_repeat_widget" ? ' full-layout barlist' : ''}${item.id == "WUniqueMemberID" ? ' full-layout barlist' : ''}${item.id == "WMetric3A" ? ' layout-left-margin barlist' : ''}${item.id == "RxSensClaim" ? ' full-layout' : ''}${item.id == "RxSensClaimNew" ? ' full-layout' : ''}${item.id == "WMetric1a" ? ' full-layout barlist' : ''}${item.id == "WPharmacyTransaction1" ? ' full-layout list' : ''}${item.id == "WPrescriberTransaction1" ? ' full-layout list' : ''}${item.id == "WRepeat_PrescriptionsTransaction" ? ' full-layout list' : ''}${item.id == "WMetric3B" ? ' full-layout barlist' : ''}${item.id == "AdvanceFilter" ? ' layout-not-margin' : ''}${item.id == "WStateTransaction" ? ' layout-not-margin barlist' : ''}${item.id == "WDrugTransaction" ? ' full-layout barlist' : ''}${item.id == "WPatientSavingTransaction" ? ' layout-left-margin list' : ''}${item.id == "WCommission" ? ' full-layout barlist' : ''}${item.id == "new_repeat_widget_Line" ? ' full-layout barlist' : ''}${item.id == "CityTransaction" ? ' layout-left-margin barlist' : ''}`} key={"graph-widget" + index}>
                                                                <div className="widget-head" key={"graph-widget-head" + index}>
                                                                    <h3>
                                                                        <a>{item.title}</a>
                                                                    </h3>
                                                                    <p>
                                                                        <a>{item.Subtitle}</a>
                                                                    </p>
                                                                </div>

                                                                <div className="widget-content" key={"graph-widget-content" + index}>
                                                                    <div className="custom-scroll">
                                                                        {

                                                                            <div className="scroll-content" style={{ height: this.state.scrollArray[this.state.graphData[index].id] }}>
                                                                                {item.type == "Bar" ? <BarChart data={item} key={"bargraph" + index} ColorCode={item.ColorCode} XlabelString={item.XlabelString} YlabelString={item.YlabelString} _Index={index} /> : null}
                                                                                {item.type == "Chart" || item.type == "Line" ? <Chart data={item} key={"linegraph" + index} XlabelString={item.XlabelString} YlabelString={item.YlabelString} _Index={index} /> : null}
                                                                                {item.type == "Column" ? <Column data={item} key={"columngraph" + index} XlabelString={item.XlabelString} YlabelString={item.YlabelString} _Index={index} /> : null}
                                                                                {item.type == "List" ? <List data={item} key={"listgraph" + index} _Index={index} handlechangea={this.handlechangea} /> : null}
                                                                                {item.type == "Pie" ? <Pie data={item} key={"piegraph" + index} _Index={index} PostData={item.RequestJson} /> : null}
                                                                                {item.type == "Column_Pie" ? <Column_Pie data={item} key={"columnpiegraph" + index} _Index={index} handlechangea={this.handlechangea} /> : null}
                                                                                {item.type == "Bar_List" ? <Bar_List data={item} key={"barlistgraph" + index} _Index={index} handlechangea={this.handlechangea} /> : null}
                                                                                {item.type == "Line_List" ? <Line_List data={item} key={"linelistgraph" + index} _Index={index} /> : null}
                                                                                {item.type == "Claim" ? <Claim data={item} key={"claimbox" + index} _Index={index} /> : null}
                                                                                {item.type == "Claim_New" ? <Claim_New data={item} key={"claimboxnew" + index} _Index={index} /> : null}
                                                                                {item.type == "MultiBar_List" ? <MultiStack_List data={item} key={"barlistgraph1" + index} _Index={index} /> : null}
                                                                                {/*{item.type == "MultiBar_List2" ? <MultiStack_List_2 data={item} key={"barlistgraph1" + index} _Index={index} /> : null}*/}
                                                                                {item.type == "MultiLine_List" ? <MultiLine_List data={item} key={"multilinelistgraph1" + index} _Index={index} /> : null}
                                                                            </div>
                                                                        }
                                                                    </div>
                                                                </div>
                                                                <div className="widget-foot">
                                                                    &nbsp;
                                                                        </div>
                                                            </div>
                                                    )
                                                })
                                            }

                                            <div className="sortby">
                                                <a href="javascript:void('0')"><img src={filterIcon} alt="filterIcon" />Calendar</a>
                                                <a href="javascript:void('0')"><img src={filterIcon} alt="filterIcon" />Filter</a>
                                            </div>

                                        </div>

                                    </div>
                                    <div className='column filter-section'>
                                        <div className="dashboard-container" id="dashboard-container">
                                            <IFrame url={APIBaseURL + "ws?wname=" + escape(this.props.dashboardName.replace(" Dashboard (wholesaler)", "").trim())} title="Filter" class="" />
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default WholesalerDashboard;
